import firebaseApp from '../firebase';

const storage = firebaseApp.storage().ref();

export const getDocumentUrl = (doc) => {
  doc.url = {};
  return storage.child(doc.url).getDownloadURL()
  .then(url=>{
    doc.url = url;
    return url
  })
}

export const deleteDocument = (doc) => {
  console.log(doc)
  const url = doc.orig || doc.url;
  let ref = firebaseApp.storage().refFromURL(url);
  ref.delete().catch(e => {
    console.log(e);
  })
}



// WEBPACK FOOTER //
// ./src/actions/documents.js